'use client';

import React from 'react';

import { Modal } from '@depop/web-ui-kit/Modal';
import { useTranslations } from 'next-intl';

import { useSellerActions } from '@/app/[locale]/products/[slug]/hooks/useSellerActions';
import { ButtonExperiment } from '@/components/ButtonExperiment';
import { useButtonPlaceholderHeight } from '@/components/ButtonExperiment/useButtonPlaceholderHeight';
import { DownloadAppModal } from '@/components/DownloadAppModal/DownloadAppModal.tsx';
import { ExtendedLink } from '@/components/ExtendedLink';
import { Placeholder, PlaceHolderShape } from '@/components/Placeholder';

type ButtonProps = React.ComponentProps<typeof ButtonExperiment>;

export type MessageSellerButtonProps = {
  className?: string;
  isShortLabel?: boolean;
} & Pick<ButtonProps, 'size'>;

export function MessageSellerButton({
  className,
  size,
  isShortLabel = false,
}: MessageSellerButtonProps) {
  const t = useTranslations('product');
  const label = isShortLabel ? t('Message') : t('MessageSeller');
  const {
    isSuccess,
    isAuthenticated,
    messagesUrl,
    handleMessageClick,
    isDownloadAppModalOpen,
    setIsDownloadAppModalOpen,
  } = useSellerActions({ messageInteractionType: 'InaRiskSellerClick' });
  const placeholderHeight = useButtonPlaceholderHeight(size);

  function renderContent() {
    if (!isSuccess) {
      return (
        <Placeholder
          shape={PlaceHolderShape.RECTANGLE}
          width="100%"
          height={placeholderHeight}
        />
      );
    }

    if (isAuthenticated) {
      return (
        <ExtendedLink href={messagesUrl} onClick={handleMessageClick}>
          <ButtonExperiment as="span" fullWidth variant="primary" size={size}>
            {label}
          </ButtonExperiment>
        </ExtendedLink>
      );
    }

    return (
      <>
        <ButtonExperiment
          fullWidth
          variant="primary"
          size={size}
          onClick={handleMessageClick}
        >
          {label}
        </ButtonExperiment>
        <Modal
          isOpen={isDownloadAppModalOpen}
          setOpen={setIsDownloadAppModalOpen}
          content={() => (
            <DownloadAppModal downloadAppTrackingId="pdp_message_seller" />
          )}
        />
      </>
    );
  }

  return <div className={className}>{renderContent()}</div>;
}
